import { notification } from "antd"
import { getMsgClient } from "src/lib/stringsUtils"
import SvgIcon from "../SvgIcon"
import "./styles.scss"

function notice({ msg = "", desc, place, isSuccess }) {
  // ✅ Xác định kiểu thông báo
  let background = "#F5F5F5"
  let icon = <SvgIcon name="notice-info" />
  let className = "neutral"

  if (isSuccess === true) {
    background = "#E5F5EB" // xanh nhạt
    icon = <SvgIcon name="notice-success" />
    className = "success"
  } else if (isSuccess === false) {
    background = "#FCCED4" // đỏ nhạt
    icon = <SvgIcon name="notice-error" />
    className = "error"
  }

  notification.open({
    className: `notification-custom ${className}`,
    style: { background },
    placement: place || "bottomRight",
    message: (
      <div
        dangerouslySetInnerHTML={{
          __html: getMsgClient(msg || ""),
        }}
      />
    ),
    description: (
      <div
        dangerouslySetInnerHTML={{
          __html: getMsgClient(desc || ""),
        }}
      />
    ),
    icon,
    duration: 3,
  })
}

export default notice
